module.exports = __webpack_public_path__ + "img/dashboardIcon.ceacd1a0.svg";